module.exports = __webpack_public_path__ + "img/full_map_with_overlay.ad8f9e53.jpg";